import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { RemoteCreateNewUser } from "../../../data/usecases/user-management/remote-create-new-user";
import { CreateNewUser } from "../../../domain/useages/user-management/create-new-user";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface CreateNewUserInterface {
  createNewUser: Function;
}

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useCreateNewUserSlice: StateCreator<CreateNewUserInterface> = (
  set,
  get
) => ({
  createNewUser: async (
    payload: CreateNewUser.Params,
    handleClose: Function
  ) => {
     const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
     const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteCreateNewUser = new RemoteCreateNewUser(
      `${BASE_URL}${Endpoints.CREATE_NEW_USER}`,
      axiosHttpClient
    );
    let result = await remoteCreateNewUser.create(payload);

    if (result) {
      handleClose();
    }
  },
});
